import { client } from '@/api/backoffice-api';
import AppConfig from "@/utils/app-config.mjs";
import { IDatasource, IGetRowsParams } from "ag-grid-community";
import { SERVER_PAGE_SIZE } from '@/model/Constants';


export default class BlacklistDealersDataSource implements IDatasource {
  /**
   * Converts an agGrid request to an API request
   * @param params the IServerSideGetRowsRequest get rows request
   */
  async fetchData(params: IGetRowsParams) {
    try {
      const sortType: { [key: string]: string } = {
        fullLicenseKey: 'fullLicenseKey',
        name: 'businessname',
        contact: 'mailstreet',
        businessType: 'type',
      }
      const sortModelType: { sort: string, colId: string } | boolean = params.sortModel.length > 0 && params.sortModel[0]
      const sortBy = sortModelType ? sortType[sortModelType?.colId] : '';
      const descending = sortModelType ? sortModelType?.sort === 'asc' ? true : false : false;
      console.log({ params, sortBy, descending });
      const params_data = {
        only_blacklisted_dealers: true,
        sortBy,
        descending,
        page_size: SERVER_PAGE_SIZE,
        page_number: params.startRow
      }
  
      const response = await client.get(
       `${AppConfig.fflExpressServiceApiURL}/dealers/search`,
        { params: params_data }
      );
      return response.data;
    } catch(error) {
      return {
        dealers: [],
        meta: { hasMore: false }
      }
    }
  }

  /**
   * Get rows from the API
   * @param params
   */
  getRows(params: IGetRowsParams): void {
    const pageNumber = (params.startRow / 30) + 1;
    this.fetchData({ ...params, startRow: pageNumber })
      .then((result) => {
        params.successCallback(
          result.data
        );
      })
      .catch((error) => {
        console.error('Error while fetching rows for ag-Grid', error);
        params.failCallback();
      });
  }
}
